/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
  Blockly.Arduino.sensor = {};

  Blockly.Arduino.sensor_potentiometer = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    var b = "map(analogRead(" + a + "), 0, 1023, 0, 100)";
    "RAW" == this.getFieldValue("RANGE") && (b = "analogRead(" + a + ")");
    return [b, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_potentiometer_lite = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    var b = "map(analogRead(" + a + "), 0, 1023, 0, 100)";
    "RAW" == this.getFieldValue("RANGE") && (b = "analogRead(" + a + ")");
    return [b, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_button = function() {
    var a = this.getFieldValue("PIN"),
      b = this.getFieldValue("INVERT");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    a = "digitalRead(" + a + ")";
    "TRUE" == b && (a = "(!" + a + ")");
    return [a, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_button_lite = function() {
    var a = this.getFieldValue("PIN"),
        b = this.getFieldValue("INVERT");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT_PULLUP);";
    a = "digitalRead(" + a + ")";
    "FALSE" == b && (a = "!(" + a + ")");
    return [a, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_tilt = Blockly.Arduino.sensor_button;
  Blockly.Arduino.sensor_tilt_lite = Blockly.Arduino.sensor_button_lite;
  Blockly.Arduino.sensor_button_debounced = function() {
    var a = this.getFieldValue("PIN"),
      b = this.getFieldValue("STATUS"),
      c = this.getFieldValue("INVERT");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    Blockly.Arduino.definitions_.define_button_debounced = '#include "Button.h"';
    Blockly.Arduino.definitions_["var_button_debounced_" + a] =
      "Button button_debounced_" + a + "(" + a + ", 50);\n";
    var d = "";
    "pressed" == b && (d = "button_debounced_" + a + ".pressed()");
    "released" == b && (d = "button_debounced_" + a + ".released()");
    "TRUE" == c && (d = "(!" + d + ")");
    return [d, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_button_debounced_lite = function() {
    var a = this.getFieldValue("PIN"),
        b = this.getFieldValue("STATUS"),
        c = this.getFieldValue("INVERT");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT_PULLUP);";
    Blockly.Arduino.definitions_.define_button_debounced = '#include "Button.h"';
    Blockly.Arduino.definitions_["var_button_debounced_" + a] =
        "Button button_debounced_" + a + "(" + a + ", 50);\n";
    var d = "";
    "released" == b && (d = "button_debounced_" + a + ".pressed()");
    "pressed" == b && (d = "button_debounced_" + a + ".released()");
    "TRUE" == c && (d = "(!" + d + ")");
    return [d, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_dht11 = function() {
    Blockly.Arduino.includes_.push(libraries.adafruit_sensor);
    Blockly.Arduino.includes_.push(libraries.dht);

    var a = this.getFieldValue("PIN"),
        b = this.getFieldValue("TYPE");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    Blockly.Arduino.setups_["setup_dht11_" + a] = "  dht11_" + a + ".begin();";
    Blockly.Arduino.definitions_.define_dht11 = '#include "DHT.h"';
    Blockly.Arduino.definitions_["var_dht11_" + a] = "DHT dht11_" + a + "(" + a + ", DHT11);";
    return [
      "temperature" == b ? "dht11_" + a + ".readTemperature()" : "dht11_" + a + ".readHumidity()",
      Blockly.Arduino.ORDER_ATOMIC
    ];
  };
  Blockly.Arduino.sensor_dht22 = function() {
    Blockly.Arduino.includes_.push(libraries.adafruit_sensor);
    Blockly.Arduino.includes_.push(libraries.dht);

    var a = this.getFieldValue("PIN"),
        b = this.getFieldValue("TYPE");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    Blockly.Arduino.setups_["setup_dht22_" + a] = "  dht22_" + a + ".begin();";
    Blockly.Arduino.definitions_.define_dht22 = '#include "DHT.h"';
    Blockly.Arduino.definitions_["var_dht22_" + a] = "DHT dht22_" + a + "(" + a + ", DHT22);";
    return [
      "temperature" == b ? "dht22_" + a + ".readTemperature()" : "dht22_" + a + ".readHumidity()",
      Blockly.Arduino.ORDER_ATOMIC
    ];
  };
  function setupUltrasonic() {
    Blockly.Arduino.definitions_fnc_.fnc_ultrasonic =
      "// Ultrasound distance function calculator\n" +
      "double fnc_ultrasonic_distance(int _t, int _e, String _u) {\n" +
      "  unsigned long dur=0;\n" +
      "  digitalWrite(_t, LOW);\n" +
      "  delayMicroseconds(5);\n" +
      "  digitalWrite(_t, HIGH);\n" +
      "  delayMicroseconds(10);\n" +
      "  digitalWrite(_t, LOW);\n" +
      "  dur = pulseIn(_e, HIGH, 18000);\n" +
      "  if (dur == 0)\n" +
      "    return 999.0;\n" +
      "  if (_u == \"cm\")\n" +
      "    return (dur/57);\n" +
      "  else if (_u == \"in\")\n" +
      "    return (dur/57) * (1 / 2.54);\n" +
      "}\n";
  }
  Blockly.Arduino.sensor_ultrasonic = function() {
    var a = this.getFieldValue("TRIGGER_PIN"),
        b = this.getFieldValue("ECHO_PIN"),
        c = this.getFieldValue("UNITS");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", OUTPUT);";
    Blockly.Arduino.setups_["setup_input_" + b] = "  pinMode(" + b + ", INPUT);\n";
    setupUltrasonic();
    return ["fnc_ultrasonic_distance(" + a + ", " + b + ", \"" + c + "\")", Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_ultrasonic2 = function() {
    var a = this.getFieldValue("TRIGGER_PIN"),
      b = this.getFieldValue("ECHO_PIN");
    Blockly.Arduino.valueToCode(this, "MAXDISTANCE", Blockly.Arduino.ORDER_ATOMIC);
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", OUTPUT);";
    Blockly.Arduino.setups_["setup_input_" + b] = "  pinMode(" + b + ", INPUT);";
    setupUltrasonic();
    return ["fnc_ultrasonic_distance(" + a + "," + b + ")", Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_ldr = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    var b = "map(analogRead(" + a + "), 0, 1023, 0, 100)";
    "RAW" == this.getFieldValue("RANGE") && (b = "analogRead(" + a + ")");
    return [b, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_ntc = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    Blockly.Arduino.definitions_.define_math = "#include <math.h>";
    Blockly.Arduino.definitions_fnc_.fnc_ntc =
      "double fnc_ntc(int _rawval)\n{\n  double temp;\n  temp = log(((10240000 / _rawval) - 10000));\n  temp = 1 / (0.001129148 + (0.000234125 + (0.0000000876741 * temp * temp ))* temp );\n  temp = temp - 273.15;\n  return temp;\n}\n";
    return ["fnc_ntc(analogRead(" + a + "))", Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_tmp36 = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    return ["((analogRead(" + a + ") * 0.48828125) - 50.0)", Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_sound = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    var b = "map(analogRead(" + a + "),0,1023,0,100)";
    "RAW" == this.getFieldValue("RANGE") && (b = "analogRead(" + a + ")");
    return [b, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_TEMT6000 = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    var b = "map(analogRead(" + a + "),0,1023,0,100)";
    "RAW" == this.getFieldValue("RANGE") && (b = "analogRead(" + a + ")");
    return [b, Blockly.Arduino.ORDER_ATOMIC];
  };
  Blockly.Arduino.sensor_TEMT6000_lite = function() {
    var a = this.getFieldValue("PIN");
    Blockly.Arduino.setups_["setup_input_" + a] = "  pinMode(" + a + ", INPUT);";
    var b = "map(analogRead(" + a + "),0,1023,0,100)";
    "RAW" == this.getFieldValue("RANGE") && (b = "analogRead(" + a + ")");
    return [b, Blockly.Arduino.ORDER_ATOMIC];
  };

  Blockly.Arduino.sensor_adxl345 = function() {
    var id = this.getFieldValue("ID");
    var os = this.getFieldValue("OFFSET");
    Blockly.Arduino.definitions_.define_wire = "#include <Wire.h>";

    Blockly.Arduino.definitions_.define_adxl345 = '#include "ADXL345.h"\n';

    Blockly.Arduino.definitions_.var_adxl345 = "ADXL345 adxl345_accel;\nVector offset;";

    Blockly.Arduino.definitions_fnc_.fnc_adxl345 =
    `double fnc_adxl345(int _type, bool _offset = true) {\n` +
    `  double v = 0.0;\n` +
    `  adxl345_accel.enableOffset(_offset);\n` +
    `  if (_type >= 1 && _type <= 3) {\n` +
    `    // Raw data\n` +
    `    Vector data_raw = adxl345_accel.readRaw();\n` +
    `    if (_type == 1) v = data_raw.XAxis;\n` +
    `    if (_type == 2) v = data_raw.YAxis;\n` +
    `    if (_type == 3) v = data_raw.ZAxis;\n` +
    `  }\n` +
    `  else {\n` +
    `    // Noramlized data\n` +
    `    Vector data_norm = adxl345_accel.readNormalize();\n` +
    `    if (_type >= 4 && _type <= 6) {\n` +
    `      if (_type == 4) v = data_norm.XAxis;\n` +
    `      if (_type == 5) v = data_norm.YAxis;\n` +
    `      if (_type == 6) v = data_norm.ZAxis;\n` +
    `    }\n` +
    `    else {\n` +
    `      // Pitch and roll angles\n` +
    `      Vector data_filtered = adxl345_accel.lowPassFilter(data_norm, 0.5);\n` +
    `      if (_type == 7) {\n` +
    `        v = (atan2(data_filtered.YAxis, data_filtered.ZAxis) * 180.0) / M_PI;\n` +
    `      }\n` +
    `      if (_type == 8) {\n` +
    `        v = -(atan2(data_filtered.XAxis,\n` +
    `          sqrt(data_filtered.YAxis * data_filtered.YAxis +\n` +
    `               data_filtered.ZAxis * data_filtered.ZAxis)) * 180.0) / M_PI;\n` +
    `      }\n` +
    `    }\n` +
    `  }\n` +
    `  return v;\n` +
    `}\n`;

    Blockly.Arduino.setups_.setup_adxl345 =
      `  // Accelerometer initialization\n` +
      `  adxl345_accel.begin();\n` +
      `  adxl345_accel.setRange(ADXL345_RANGE_16G);\n` +
      `  delay(10);\n\n` +
      `  // Software offset compensation\n` +
      `  offset.XAxis = fnc_adxl345(1);   delay(10);\n` +
      `  offset.YAxis = fnc_adxl345(2);   delay(10);\n` +
      `  offset.ZAxis = fnc_adxl345(3);   delay(10);\n` +
      `  adxl345_accel.setOffset(offset);\n`;


    return ["fnc_adxl345(" + id + ", " + (os == 'TRUE'? 'true' : 'false') +")", Blockly.Arduino.ORDER_ATOMIC];
  };

  function setupColorSensorTCS34725() {
    Blockly.Arduino.definitions_.define_wire = "#include <Wire.h>";
    Blockly.Arduino.definitions_.define_TCS34725 = '#include "Adafruit_TCS34725.h"\n';
    Blockly.Arduino.definitions_.define_colorconverter = '#include "ColorConverterLib.h"\n';
    Blockly.Arduino.definitions_.var_TCS34725 =
      "Adafruit_TCS34725 tcs34725 = Adafruit_TCS34725(TCS34725_INTEGRATIONTIME_50MS, TCS34725_GAIN_1X);";
    Blockly.Arduino.definitions_.var_TCS34725_r = "double  tcs34725_r=0;";
    Blockly.Arduino.definitions_.var_TCS34725_g = "double  tcs34725_g=0;";
    Blockly.Arduino.definitions_.var_TCS34725_b = "double  tcs34725_b=0;";
    Blockly.Arduino.definitions_.var_TCS34725_clear = "uint16_t  tcs34725_clear=0;";
    Blockly.Arduino.definitions_.var_TCS34725_h = "double  tcs34725_h=0;";
    Blockly.Arduino.definitions_.var_TCS34725_s = "double  tcs34725_s=0;";
    Blockly.Arduino.definitions_.var_TCS34725_v = "double  tcs34725_v=0;";
    Blockly.Arduino.setups_.setup_TCS34725 = "  tcs34725.begin();";
    Blockly.Arduino.definitions_fnc_.fnc_tcs34725 =
      "void fnc_tcs34725_capturecolor()\n{\n  uint16_t tcs_red, tcs_green, tcs_blue;\n  tcs34725.getRawData(&tcs_red, &tcs_green, &tcs_blue, &tcs34725_clear);\n  if (tcs34725_clear == 0) {\n    tcs34725_r=tcs34725_g=tcs34725_b=0;\n    return;\n  }\n  tcs34725_r = ((float)tcs_red / (float)tcs34725_clear * 255.0);\n  tcs34725_g = ((float)tcs_green / (float)tcs34725_clear * 255.0);\n  tcs34725_b = ((float)tcs_blue / (float)tcs34725_clear * 255.0);\n  ColorConverter::RgbToHsv(static_cast<uint8_t>(tcs34725_r), static_cast<uint8_t>(tcs34725_g), static_cast<uint8_t>(tcs34725_b), tcs34725_h, tcs34725_s,tcs34725_v);\n  tcs34725_h=tcs34725_h*360;\n  tcs34725_s=tcs34725_s*100;\n  tcs34725_v=tcs34725_v*100;\n}\n";
  }
}